export enum OrganizationUserApiErrorTypes {
  ServiceUnavailableError,
  BadRequestError,
  ConflictError,
}

export class OrganizationUserApiError {
  constructor(public type: OrganizationUserApiErrorTypes, public error: Error) {}
}
